import http from '@/core/http';
import {
  IManageProjectPageReq,
  IManageProjectPageRes,
  IManageProjectRes,
  IManageCreateReq,
  IManageCreateRes,
  IModifyUserReq,
  IModifyStateReq,
  IManageBatchCreatePMRes,
  IManageBatchCreatePMReq,
  IManageQueryProjectByLikeRes,
  serviceBasicInfoRes,
  ISecondLevelMenuByLikeReq,
  ISecondLevelMenuByLikeRes,
  IManageQueryListRes,
  IManageQueryListReq,
  IManageListRes,
  IManageListReq,
  IManageCreatePMReq,
  IManageCreatePMRes,
  IManageUpdateBatchPMReq,
  IManageUpdateBatchPMRes,
  IManageUpdatePMReq,
  IManageUpdatePMRes,
  IManageQueryHeadOfBackendReq,
  IManageQueryHeadOfBackendRes,
  IProjectUpdateParentProjectInfoReq,
  IProjectUpdateParentProjectInfoRes,
  IProjectQueryAllParentProjectRes,
  IProjectQueryAllParentProjectReq,
} from './type.d';

/**
 * 项目服务:通过二级菜单名称keyword进行模糊查询
 */
export const manageQuerySecondLevelMenuByLike = (
  params: ISecondLevelMenuByLikeReq,
) => {
  return http.post<ISecondLevelMenuByLikeRes>({
    url: '/management/web/v1/manage/project/query-second-level-menu-by-like',
    data: params,
    loading: false,
  });
};
/**
 * 项目服务:获取所有服务名称以及对应的负责人
 */
export const manageSelectAllServiceBasicInfo = () => {
  return http.post<serviceBasicInfoRes>({
    url: '/management/web/v1/manage/project/query-all-service-basic-info',
    loading: false,
  });
};

/**
 * 项目服务:通过项目名称keyword进行模糊查询
 */
export const manageQueryProjectByLike = (keyword: string) => {
  return http.get<IManageQueryProjectByLikeRes>({
    url: `/management/web/v1/manage/project/query-project-by-like/${keyword}`,
    loading: false,
  });
};

/**
 * 项目服务==>批量 新增项目服务/一级菜单、二级菜单
 */
export const manageBatchCreatePM = (params: IManageBatchCreatePMReq) => {
  return http.post<IManageBatchCreatePMRes>({
    url: '/management/web/v1/manage/project/batch-save',
    data: params,
    loading: true,
  });
};

/**
 * 审批查询
 * @see https://yapi.ibaibu.com/project/1878/interface/api/201905
 */
export function getApproveList(data: IManageProjectPageReq) {
  return http.post<IManageProjectPageRes>({
    url: '/management/web/v1/manage/backend/page',
    loading: true,
    data,
  });
}

/**
 * 审批新增
 * @see https://yapi.ibaibu.com/project/1878/interface/api/201921
 */
export function createApproveInfo(data: IManageCreateReq) {
  return http.post<IManageCreateRes>({
    url: '/management/web/v1/manage/backend/save',
    loading: true,
    data,
  });
}

/**
 * 审批通过编辑
 * @see https://yapi.ibaibu.com/project/1878/interface/api/201961
 */
export function editApproveInfo(data: IModifyUserReq) {
  return http.post({
    url: '/management/web/v1/manage/backend/update-head-of-backend',
    loading: true,
    data,
  });
}

/**
 * 审批更改公共服务状态
 * @see https://yapi.ibaibu.com/project/1878/interface/api/201953
 */
export function updatePublicServiceState(data: IModifyStateReq) {
  return http.post({
    url: '/management/web/v1/manage/backend/update-is-public-service',
    loading: true,
    data,
  });
}
/**
 * 审批更改保留/弃用状态
 * @see https://yapi.ibaibu.com/project/1878/interface/api/201945
 */
export function updateDeprecatedState(data: IModifyStateReq) {
  return http.post({
    url: '/management/web/v1/manage/backend/update-is-deprecated',
    loading: true,
    data,
  });
}

/**
 * 审批拒绝后上次提交的申请详情
 * @see https://yapi.ibaibu.com/project/1878/interface/api/201929
 */
export function retrieveBeforeApproveInfo(serviceId: string) {
  return http.get<IManageCreateReq>({
    url: `/management/web/v1/manage/backend/update/${serviceId}`,
    loading: true,
  });
}

/**
 * 审批操作日志
 * @see https://yapi.ibaibu.com/project/1878/interface/api/201937
 */
export function getLogList(serviceId: string) {
  return http.get({
    url: `/management/web/v1/manage/backend/operation-log/${serviceId}`,
    loading: true,
  });
}

/**
 * 审批流程日志
 * @see https://yapi.ibaibu.com/project/1878/interface/api/201913
 */
export function getProcessLogList(serviceId: string) {
  return http.get({
    url: `/management/web/v1/manage/backend/apply-process/${serviceId}`,
    loading: true,
  });
}
/**
 * 查询运维审批日志
 * @see https://yapi.ibaibu.com/project/1878/interface/api/210809
 */
export function getOpsApplyProcessLogList(serviceId: string) {
  return http.get({
    url: `/management/web/v1/manage/backend/ops-apply-process/${serviceId}`,
    loading: true,
  });
}
/**
 * 审批详情
 * @see https://yapi.ibaibu.com/project/1878/interface/api/201969
 */
export function retrieveApproveInfo(serviceId: string) {
  return http.get<IManageProjectRes>({
    url: `/management/web/v1/manage/backend/detail/${serviceId}`,
    loading: true,
  });
}
/**
 * 条件查询分组
 * @see https://yapi.ibaibu.com/project/1878/interface/api/201985
 *  @请求方法：POST
 *  @请求地址：/management/web/v1/manage/project/page
 * @更新时间：2022-08-21 13:39:10
 */

export const fetchSearch = (data:IManageQueryListReq) => {
  return http.post<IManageQueryListRes>({
    url: '/management/web/v1/manage/project/page',
    data,
    loading: true,
  });
};

/**
 * 列表
 * @see https://yapi.ibaibu.com/project/1878/interface/api/192705
 * @请求方法：POST
 * @请求地址：/management/web/v1/manage/project/page
 * @更新时间：2022-08-15 10:01:35
 */

export const fetchList = (data: IManageListReq) => {
  return http.post<IManageListRes>({
    url: '/management/web/v1/manage/project/page',
    data,
    loading: true,
  });
};

/**
 * 新增项目服务
 * @see https://yapi.ibaibu.com/project/1878/interface/api/192713
 * @请求方法：POST
 * @请求地址：/management/web/v1/manage/createPM
 * @更新时间：2022-08-10 15:34:02
 */
export const addService = (data: IManageCreatePMReq) => {
  return http.post<IManageCreatePMRes>({
    url: '/management/web/v1/manage/createPM',
    data,
  });
};

/**
 * 批量编辑
 * @see https://yapi.ibaibu.com/project/1878/interface/api/202017
 * @请求方法：POST
 * @请求地址：/management/web/v1/manage/project/batch-update
 * @更新时间：2022-08-21 13:39:11
 */
export const bulkEdit = (data: IManageUpdateBatchPMReq) => {
  return http.post<IManageUpdateBatchPMRes>({
    url: '/management/web/v1/manage/project/batch-update',
    data,
  });
};
/**
 * 单条编辑
 * @see https://yapi.ibaibu.com/project/1878/interface/api/202009
 * @请求方法：POST
 * @请求地址：/management/web/v1/manage/project/update
 * @更新时间：2022-08-21 13:39:10
 */
export const singleEdit = (data: IManageUpdatePMReq) => {
  return http.post<IManageUpdatePMRes>({
    url: '/management/web/v1/manage/project/update',
    data,
  });
};

/**
 * 通过后端服务名称获取后端负责人
 * @see https://yapi.ibaibu.com/project/1878/interface/api/202041
 * @请求方法：POST
 * @请求地址：/management/web/v1/manage/project/query-head-of-backend
 * @更新时间：2022-09-07 10:15:42

 */
export const matchBackendPerson = (data: IManageQueryHeadOfBackendReq) => {
  return http.post<IManageQueryHeadOfBackendRes>({
    url: '/management/web/v1/manage/project/query-head-of-backend',
    data,
  });
};

/**
 * 批量 新增项目服务/一级菜单、二级菜单
 * @see https://yapi.ibaibu.com/project/1878/interface/api/198737
 * @请求方法：POST
 * @请求地址：/management/web/v1/manage/batchCreatePM
 * @更新时间：2022-08-16 18:09:48
 */
export const bulkAddService = (data: IManageBatchCreatePMReq) => {
  return http.post<IManageBatchCreatePMRes>({
    url: '/management/web/v1/manage/batchCreatePM',
    data,
  });
};

/**
 * 修改项目名称和域名地址
 * @see https://yapi.ibaibu.com/project/1878/interface/api/207585
 * @请求方法：POST
 * @请求地址：/management/web/v1/manage/project/update-parent-project-info
 * @更新时间：2022-08-29 10:50:28

 */
export const updateParentProjectInfo = (data: IProjectUpdateParentProjectInfoReq) => {
  return http.post<IProjectUpdateParentProjectInfoRes>({
    url: '/management/web/v1/manage/project/update-parent-project-info',
    data,
  });
};

/**
 * 获取所有项目名称、域名地址
 * @see https://yapi.ibaibu.com/project/1878/interface/api/208009
 * @请求方法：POST
 * @请求地址：/management/web/v1/manage/project/query-all-parent-project
 * @更新时间：2022-08-29 16:05:32
 */
export const queryAllParentProject = (data?: IProjectQueryAllParentProjectReq) => {
  return http.post<IProjectQueryAllParentProjectRes>({
    url: '/management/web/v1/manage/project/query-all-parent-project',
    data,
  });
};

/**
 * 根据项目名称获取域名地址
 * @see https://yapi.ibaibu.com/project/1878/interface/api/202033
 * @请求方法：POST
 * @请求地址：/management/web/v1/manage/project/query-domain-name
 * @更新时间：2022-08-29 16:05:32
 */
export const queryDomainName = (data?: IProjectQueryAllParentProjectReq) => {
  return http.post<IProjectQueryAllParentProjectRes>({
    url: '/management/web/v1/manage/project/query-domain-name',
    data,
  });
};
